export const INITIALIZE = 'oomShoppingListInitialize'
export const CLOSE_WIDGET = 'oomShoppingListCloseWidget'
export const LIST_SAVED = 'oomShoppingListSaved'
export const WIDGET_CONFIGURED = 'oomShoppingListConfigured'
